import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { jwtDecode, JwtPayload } from 'jwt-decode';

interface ClinchJwtPayload extends JwtPayload {
  operator?: string;
  clinchUserId?: string;
}

export class Token {
  static async get(forceRefresh = false): Promise<string> {
    const result = await FirebaseAuthentication.getIdToken({
      forceRefresh,
    });
    if (result.token) {
      return result.token;
    }
    throw new Error('No Firebase id token');
  }

  static async hasClinchUserId(): Promise<boolean> {
    const idToken = await Token.get();
    const decodedToken = jwtDecode<ClinchJwtPayload>(idToken);

    // Return true if custom claims already has a Clinch userId
    return decodedToken?.clinchUserId !== undefined;
  }
}
